import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateSourceInput } from '../../../actions/SearchParameter.Actions';
import MultiChipInput from '../../../components/MultiChipInput';

class DataSourceField extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateSourceInput = this.handleUpdateSourceInput.bind(this);
  }

  handleUpdateSourceInput({ results }) {
    const { dispatch } = this.props;
    dispatch(updateSourceInput(results));
  }

  render() {
    const { source: { available, input } } = this.props;

    return (
      <MultiChipInput
        label="Search by Data Source"
        data={available}
        bindInput={input}
        onChipDelete={this.handleUpdateSourceInput}
        onChipCreate={this.handleUpdateSourceInput}
        onSelectAll={this.handleUpdateSourceInput}
        onDeleteAll={this.handleUpdateSourceInput}
      />
    );
  }
}

DataSourceField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  source: PropTypes.shape({
    available: PropTypes.arrayOf(PropTypes.string).isRequired,
    input: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

function mapStateToProps({ SearchParameter: { source } }) {
  return { source };
}

export default connect(mapStateToProps)(DataSourceField);



// WEBPACK FOOTER //
// ./src/containers/Aside/ImageSearchGroup/DataSourceField.jsx